import React from 'react';
import Divider from '../../../ui/Divider/Divider';
import { LayoutTree } from '../../DynamicLayout';
import useOrderTracking from '../../../../hooks/useOrderTracking';
import CarrierTrackingLink from '../CarrierTrackingLink';
import TrackingEvents from './components/TrackingEvents';
import TrackingEventsList from './components/TrackingEventsList';
import TrackingEventDescription from './components/TrackingEventDescription';

export { TrackingEventsList, TrackingEventDescription };

const { FeatureLayout } = LayoutTree;

export interface ShippingActivityProps {
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
}

const ShippingActivity = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
}: ShippingActivityProps) => {
  const { getCurrentShipment } = useOrderTracking();
  const currentShipment = getCurrentShipment();

  if (!currentShipment) return null;

  const { trackingNumber = '' } = currentShipment;

  return (
    <div
      data-test="shippingHistoryContainer"
      data-testid="shippingHistoryContainer"
    >
      {layout === FeatureLayout.PORTRAIT && <Divider />}
      <TrackingEvents featureName={featureName} />
      {trackingNumber && (
        <>
          <Divider />
          <CarrierTrackingLink featureName={featureName} layout={layout} />
        </>
      )}
    </div>
  );
};

export default ShippingActivity;
